/**
 * @generated SignedSource<<b6ade959c2f08968393f48905313dd91>>
 * @relayHash e0daa3cc39578a0c6d16892c620ba652
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0daa3cc39578a0c6d16892c620ba652

import type { ConcreteRequest } from 'relay-runtime';
export type AddBlockedByInput = {
  blockingIssueId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
};
export type createIssueAddBlockedByMutation$variables = {
  input: AddBlockedByInput;
};
export type createIssueAddBlockedByMutation$data = {
  readonly addBlockedBy: {
    readonly blockingIssue: {
      readonly id: string;
    } | null | undefined;
    readonly issue: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueAddBlockedByMutation$rawResponse = {
  readonly addBlockedBy: {
    readonly blockingIssue: {
      readonly id: string;
    } | null | undefined;
    readonly issue: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueAddBlockedByMutation = {
  rawResponse: createIssueAddBlockedByMutation$rawResponse;
  response: createIssueAddBlockedByMutation$data;
  variables: createIssueAddBlockedByMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddBlockedByPayload",
    "kind": "LinkedField",
    "name": "addBlockedBy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "blockingIssue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createIssueAddBlockedByMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createIssueAddBlockedByMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "e0daa3cc39578a0c6d16892c620ba652",
    "metadata": {},
    "name": "createIssueAddBlockedByMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bddab089b466747a365e4f8c57ef56f1";

export default node;
